import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";

import { LanguageModule } from "@intocare/language";

import { IcFormsModule } from "../../core";

@Component({
	selector: "custom-form-text",
	imports: [CommonModule, IcFormsModule, LanguageModule, ReactiveFormsModule],
	template: `
		<div class="dynamic-field form-text" [formGroup]="group">
			<ic-form-field>
				<span icLabel><ng-content select="h3" /></span>

				<input
					icInput
					type="text"
					[formControlName]="config.name"
					[maxlength]="config.maxLength"
					[minlength]="config.minLength"
					[pattern]="config.pattern"
					[placeholder]="placeholder | language"
				/>

				@if (config.suffix?.type === "icon") {
					<span class="suffix suffix-icon" icSuffix [ngClass]="config.suffix?.value"> </span>
				}

				@if (config.suffix?.type === "text") {
					<span class="suffix suffix-text" icSuffix> FOO </span>
				}
			</ic-form-field>
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormTextComponent {
	@Input() config: any;
	@Input() group: UntypedFormGroup;

	get placeholder() {
		return this.config.placeholder || "";
	}
}
